import { ValidationSchema } from 'forms';
import { BANK_ACCOUNT_NUMBER_REGEX, BANK_IFSC_REGEX } from 'utils/regexes';
import { BankAccountFormData } from './types';

const validateAccountNumber = (formData: Partial<BankAccountFormData>) => {
  if (!formData.accountNumber) return 'Please enter account number';

  if (!BANK_ACCOUNT_NUMBER_REGEX.test(formData.accountNumber))
    return 'Please enter valid account number';

  return null;
};

const validateConfirmAccountNumber = (formData: Partial<BankAccountFormData>) => {
  if (formData.accountNumber && !formData.confirmAccountNumber)
    return 'Please confirm account number';

  if (formData.accountNumber !== formData.confirmAccountNumber)
    return 'Account number and confirm account number do not match';

  return null;
};

const validateIfscCode = (formData: Partial<BankAccountFormData>) => {
  if (!formData.ifscCode) return 'Please enter IFSC code';

  if (!BANK_IFSC_REGEX.test(formData.ifscCode)) return 'Please enter valid IFSC code';

  return null;
};

const validateBeneficiaryName = (formData: Partial<BankAccountFormData>) => {
  if (!formData.beneficiaryName?.trim())
    return 'Please enter account holder name';

  if (formData.beneficiaryName.length > 255)
    return 'Account holder name cannot be more than 255 characters';

  return null;
};

export const bankAccountValidationSchemaWithProof: ValidationSchema<BankAccountFormData> = {
  accountNumber: validateAccountNumber,
  confirmAccountNumber: validateConfirmAccountNumber,
  ifscCode: validateIfscCode,
  bankProofType: (formData) => {
    if (!formData.bankProofType) return `Please select proof type`;
    return null;
  },
  bankProofFile: (formData) => {
    if (!formData.bankProofFile) return `Please upload file`;
    return null;
  },
  beneficiaryName: validateBeneficiaryName,
};

export const bankAccountValidationSchemaForAdmin: ValidationSchema<BankAccountFormData> = {
  accountNumber: validateAccountNumber,
  confirmAccountNumber: validateConfirmAccountNumber,
  ifscCode: validateIfscCode,
  beneficiaryName: validateBeneficiaryName,
};

export const bankAccountValidationSchema: ValidationSchema<BankAccountFormData> = {
  accountNumber: validateAccountNumber,
  confirmAccountNumber: validateConfirmAccountNumber,
  ifscCode: validateIfscCode,
};
